export default __webpack_public_path__ + "static/media/desktop-step2.61cb76ac.png";